export function getProvider(inputUrl: string) {
  for (const { matchers, htmlFixer, oembed } of Object.values(OembedProviders)) {
    if (matchers.some((matcher) => matcher.test(inputUrl))) {
      return { htmlFixer, url: oembed(inputUrl) };
    }
  }

  return { htmlFixer: () => '', url: '' };
}

export interface Provider {
  oembed: (inputUrl: string) => string;
  htmlFixer: (html: string) => string;
}

function iframeFixer(content: string) {
  content = forceNoRel(content);
  return content.replace(/><\/iframe>$/, ' style="width:100%;height:100%;position:absolute;top:0;left:0"></iframe>');
}

function forceNoRel(content: string) {
  return content.replace(/\?feature=oembed/, '?feature=oembed&rel=0');
}

interface ProviderWithMatchers extends Provider {
  matchers: Array<RegExp>;
}

const OembedProviders: Record<string, ProviderWithMatchers> = {
  YOUTUBE: {
    matchers: [
      /^https:\/\/.+\.youtube\.com\/watch.+/,
      /^https:\/\/youtube\.com\/watch.+/,
      /^https:\/\/.+\.youtube\.com\/v\/.*/,
      /^https:\/\/youtube\.com\/v\/.*/,
      /^https:\/\/youtu\.be\/.+/,
    ],
    oembed(inputUrl: string) {
      const url = new URL('https://www.youtube-nocookie.com/oembed');
      url.searchParams.set('url', inputUrl);
      return url.toString();
    },
    htmlFixer(html: string) {
      return iframeFixer(html.replace(/youtube\.com/g, 'youtube-nocookie.com'));
    },
  },
  VIMEO: {
    matchers: [
      /^https:\/\/vimeo\.com\/.+/,
      /^https:\/\/vimeo\.com\/album\/[^/]+\/video\/.+/,
      /^https:\/\/vimeo\.com\/groups\/[^/]+\/videos\/.+/,
      /^https:\/\/vimeo\.com\/ondemand\/.+/,
      /^https:\/\/player\.vimeo\.com\/video\/.+/,
    ],
    oembed(inputUrl: string) {
      const url = new URL('https://vimeo.com/api/oembed.json');
      url.searchParams.set('url', inputUrl);
      url.searchParams.set('dnt', '1');
      return url.toString();
    },
    htmlFixer(html: string) {
      let fixed = html;
      const matches = html.match(/src="([^"]+)"/);
      if (matches && matches.length >= 2) {
        const url = new URL(matches[1]);
        url.searchParams.set('dnt', '1');
        fixed = html.replace(matches[1], url.toString());
      }
      return iframeFixer(fixed);
    },
  },
};
